import React, { useEffect, useRef } from "react";
import ApexTree from "apextree";

interface TreeComponentProps {
    familyTreeData: any;
}

const transformFamilyTreeData = (node: any): any => {
    if (!node) return null;
    const transformedNode = {
        id: node.name + Math.random().toString(36).substr(2, 9),
        name: node.name,
        data: {
            imageURL: node.image || "",
            name: node.name,
            spouse: node.spouse
                ? {
                    name: node.spouse.name,
                    imageURL: node.spouse.image || "",
                }
                : null,
        },
        options: {
            nodeBGColor: "#cdb4db",
            nodeBGColorHover: "#cdb4db",
        },
        children: node.children ? node.children.map(transformFamilyTreeData).filter(Boolean) : [],
    };

    return transformedNode;
};

const TreeComponent: React.FC<TreeComponentProps> = ({ familyTreeData }) => {
    const treeContainerRef = useRef<any>(null);
    const treeInstance = useRef<any>(null);

    const options: any = {
        contentKey: "data",
        width: 1200,
        height: 800,
        nodeWidth: 250,
        nodeHeight: 100,
        fontColor: "#000",
        borderColor: "#333",
        childrenSpacing: 50,
        siblingSpacing: 30,
        direction: "top",
        highlightOnHover: true,
        enableToolbar: true,
        enableZoom: true,
        enablePan: true,

        zoomInitial: 0.7,
        zoomMin: 0.3,
        zoomMax: 2,
        autoCenter: true,
        fitToContainer: true,
        containerClassName: "custom-tree-container",
        canvasStyle: "border: 1px solid black; background: #f6f6f6;",
        nodeTemplate: (content: any) => {
            const spouseHTML = content.spouse
                ? `<div style='display: flex; flex-direction: column; align-items: center; justify-content:center;'>
             <img style='width: 50px; height: 50px; border-radius: 50%;' src='${content.spouse.imageURL}' alt='' />
             <div style="font-weight: bold; font-family: Arial; font-size: 14px;">${content.spouse.name}</div>
           </div>`
                : "";

            return `
        <div style="display: flex; flex-direction: row; align-items: center; gap: 20px; justify-content:center;">
          <div style='display: flex; flex-direction: column; align-items: center;'>
            <img style='width: 50px; height: 50px; border-radius: 50%;' src='${content.imageURL}' alt='' />
            <div style="font-weight: bold; font-family: Arial; font-size: 14px;">${content.name}</div>
          </div>
          ${spouseHTML}
        </div>
      `;
        },
    };

    useEffect(() => {
        if (treeContainerRef.current && !treeInstance.current) {
            treeInstance.current = new ApexTree(treeContainerRef.current, options);
            const transformedData = transformFamilyTreeData(familyTreeData);
            treeInstance.current.render(transformedData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            id="svg-tree"
            ref={treeContainerRef}
            style={{ width: "100%", height: "800px", WebkitOverflowScrolling: "touch", }}
        />
    );
};

export default TreeComponent;
